import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import type { FC } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import type { RootState } from 'src/state/store'
import HintAction from './HintAction'
import HintName from './HintName'

const HintTable: FC = () => {
  const templateHints = useSelector(
    (state: RootState) => state.templatesState.templateHints.templateHints,
    shallowEqual,
  )

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell size="small" sx={{ width: '90%' }}>
            ヒント
          </TableCell>
          <TableCell size="small" sx={{ width: '10%' }}>
            削除
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody sx={{ backgroundColor: 'white' }}>
        {templateHints.map(hint => (
          <TableRow key={hint.id}>
            <TableCell size="small">
              <HintName hint={hint} />
            </TableCell>
            <TableCell size="small">
              <HintAction hint={hint} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default HintTable
